export const MENU_SECTIONS = [
  { name: 'About', path: 'about' },
  { name: 'Collaborators', path: 'Collaborators' },
  { name: 'Sections', path: 'sections' },
  { name: 'Progress', path: 'progress' },
  { name: 'FAQ', path: 'faq' },
];

export const TEAM = [
  {
    name: 'Alberto Esquivel',
    text: '',
    avatar:
      'https://scontent-dfw5-1.xx.fbcdn.net/v/t1.6435-9/72650239_2495946783785482_1474312971063656448_n.jpg?_nc_cat=103&ccb=1-3&_nc_sid=09cbfe&_nc_eui2=AeG8-MH7zHGb6CEnoaJjAY4poOIoHGAGhNmg4igcYAaE2cqmQwUiufbUdsUR1DQwxhc&_nc_ohc=sHg2kBk3-mUAX-LY6aK&_nc_ht=scontent-dfw5-1.xx&oh=8a470b010ae60f0903661eceeb077427&oe=60C91ACA',
    link: 'https://www.linkedin.com/in/aesquivelv/',
  },
  {
    name: 'Manuel Calva',
    text: 'Student of Computer Systems and Data Science enthusiast. At the moment, dummy programmer looking to improve, voice clips hater in my free time.',
    avatar: 'images/Collaborators/Manuel.jpeg',
    link: 'https://www.linkedin.com/in/jmch7795/',
  },
  {
    name: 'Sergio Sánchez',
    text: 'Software Engineer Student',
    avatar: 'images/Collaborators/Sergio.jpeg',
    link: 'https://www.linkedin.com/in/sergiosanchez97/',
  },
  {
    name: 'Abigail Nicolás',
    text: '',
    avatar: 'images/Collaborators/Abigail.jpeg',
    link: 'https://www.linkedin.com/in/abigail-nic-say/',
  },
  {
    name: 'Erick Vargas',
    text: '',
    avatar: 'images/Collaborators/Erick.jpeg',
    link: 'https://www.linkedin.com/in/eerick1997/',
  },
  {
    name: 'Roberto Reyes',
    text: "I'm very interested in data engineering and distributed algorithms. Besides my technical background I also used to work as a user experience designer, which gives me a good understanding of user interface design.",
    avatar: 'images/Collaborators/Roberto.jpeg',
    link: 'https://www.linkedin.com/in/roberto-reyes-fragoso/',
  },
  {
    name: 'Andrés Rodarte',
    text: 'I am a Computer Systems Engineering Student from México. I like to develop web apps for all kinds of solutions from games to personal blogs.',
    avatar: 'images/Collaborators/Andres.jpeg',
    link: 'https://www.linkedin.com/in/andr%C3%A9s-rodarte-l%C3%B3pez/',
  },
  {
    name: 'Hugo Duhart',
    text: '',
    avatar: 'images/Collaborators/Duhart.jpeg',
    link: 'https://www.linkedin.com/in/vhjd',
  },
  {
    name: 'Carlos Paredes',
    text: 'Computer Systems Engineering student that likes helping others build their programming and social skills throught many growing student-based ogranizations. Aiming to be a global life changing factor building software that everyone can use regardless their capabilities.',
    avatar: 'images/Collaborators/Carlos.jpeg',
    link: 'https://www.linkedin.com/in/carlosparedescid',
  },
  {
    name: 'Óscar Rosas',
    text: 'Computer Science student at UNAM | Computer Systems at ESCOM IPN. Former Software Engineer Intern at Facebook; Incoming SWE intern at Microsoft.',
    avatar: 'images/Collaborators/Oscar.jpeg',
    link: 'https://www.linkedin.com/in/soyoscarrh',
  },
  {
    name: 'Daniela Vera',
    text: '',
    avatar: 'images/Collaborators/Daniela.jpeg',
    link: 'https://www.linkedin.com/in/daniela-vera-garc%C3%ADa-70766a207/',
  },
  {
    name: 'Juan Carlos Medina',
    text: '',
    avatar: 'images/Collaborators/Medina.jpeg',
    link: 'https://www.linkedin.com/in/medinajcarlos/',
  },
];

export const COLLABORATORS = [
  {
    name: 'Filiberto Fuentes Hernandez',
    text: 'Passionate about competitive programming. 2 times World Finalist ICPC.',
    avatar: 'images/Collaborators/Filiberto.jpeg',
    title: 'Software Engineer @ Microsoft',
  },
  {
    name: 'Carlos Laguna',
    text: 'My main interest is Machine Learning and Data Engineering.',
    avatar: 'images/Collaborators/CarlosL.jpeg',
    title: 'Data Engineer @ Microsoft',
  },
  {
    name: 'Antonio Feregrino',
    text: 'Data scientist with software development experience.',
    avatar: 'images/Collaborators/Feregrino.jpeg',
    title: 'Data Science + Software Development @ Simply Business.',
  },
  {
    name: 'Antonio Sanchez',
    text: "I'm a software engineer passionate about autonomous driving. I'm currently working on advanced driver-assistance systems (ADAS), optimizing algorithms for object detection. I'm excited to combine my experience in control theory with my software development skills at Continental. Skills: C, C++, Python, Matlab, Simulink.",
    avatar:
      'https://media-exp1.licdn.com/dms/image/C4E03AQEPabpKbgo64Q/profile-displayphoto-shrink_800_800/0/1610220222508?e=1626912000&v=beta&t=DuXlWe66dC-1dF3abz8BROrMiXtQ6MrqE6CMDaqK8bs',
    title: 'Sr. Algorithm Engineer @ Continental',
  },
  {
    name: 'Rafa Díaz',
    text: 'Aimed to help my community by working on projects that promote education, Computer Science, and empower young students from diverse backgrounds.',
    avatar: 'images/Collaborators/Rafa.jpeg',
    title: 'SWE @ Google, Director @ OmegaUp, Artist',
  },
  {
    name: 'Pablo Domínguez Durán',
    text: 'Incoming SWE intern @google. Google DSC Lead @dscipnupiita. Mechatronics Eng. student at IPNmx.',
    avatar: 'images/Collaborators/Pablo.jpeg',
    title: 'Incoming STEP Intern @ Google, Student @ UPIITA-IPN',
  },
  {
    name: 'Miguel Ángel Morales Vázquez',
    text: '',
    avatar: 'images/Collaborators/Miguel.jpeg',
    title: 'Student @ UPIITA-IPN',
  },
  {
    name: 'Enya Quetzalli Gómez Rodríguez',
    text: "Student of the Superior School of Computer Sciences (ESCOM-IPN) and a member (+teacher) of the ESCOM's Algorithmic Club where I like to organize events, contest and activities with the purpose of help.",
    avatar: 'images/Collaborators/Enya.jpeg',
    title: 'Incoming SWE Intern @ Microsoft',
  },
  {
    name: 'Oswaldo Leyva Barrientos',
    text: 'Computational Systems Engineering student with experience in software development.',
    avatar: 'images/Collaborators/Oswaldo.jpeg',
    title: 'Student @ ESCOM-IPN',
  },
  {
    name: 'Jesús Kaimorts Díaz Medina',
    text: 'Computer Systems Engineering Student at ESCOM-IPN ¡Enjoy the road! ;)',
    avatar: 'images/Collaborators/Kaimorts.jpeg',
    title: 'Systems Analyst @ Banco de México',
  },
  {
    name: 'Samuel Salas',
    text: 'I am a CS junior who seeks to find ways to solve problems.',
    avatar: 'images/Collaborators/Samuel.jpeg',
    title: 'Computer Science Student @ UNAM',
  },
  {
    name: 'Uriel Rivas',
    text: "Very practical person who will find a way to fit in anywhere he's assigned to. I'm willing to demonstrate my skills and partnership when the opportunity come. I'm currently acquiring Frontend experience using React and focusing on the user experience and.",
    avatar: 'images/Collaborators/Uriel.jpeg',
    title: 'Incoming SWE Intern @ Facebook',
  },
  {
    name: 'David Vega Ramírez',
    text: '',
    avatar: 'images/Collaborators/Vega.jpeg',
    title: 'Software Engineer @ Microsoft',
  },
  {
    name: 'Miguel Angel Maya Hernández',
    text: '',
    avatar: 'images/Collaborators/Maya.jpeg',
    title: 'Software Engineer @ Facebook',
  },
  {
    name: 'Cesar Hernández Tavera',
    text: 'I like to solve problems from programing contest and coding interviews.',
    avatar: 'images/Collaborators/Cesar.jpeg',
    title: 'Student @ ESCOM-IPN',
  },
];
